import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row md:flex-wrap gap-x-10 gap-y-4 p-5" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "flex items-center justify-start" }
const _hoisted_5 = { class: "text-xs md:text-base" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_7 = { class: "text-xs md:text-base" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_9 = { class: "text-xs md:text-base" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_11 = { class: "text-xs md:text-base" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_13 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_14 = {
  class: "w-full md:w-3/5",
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_15 = {
  class: "w-full md:w-2/5 md:pb-5",
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_16 = { class: "mb-2 text-lg font-semibold text-gray-700" }
const _hoisted_17 = { class: "flex flex-wrap justify-center items-center pt-4 space-x-6" }
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_ChartComponent = _resolveComponent("ChartComponent")!
  const _component_MapComponent = _resolveComponent("MapComponent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, {
    style: {"height":"calc(100vh - 80px)"},
    class: "bg-white"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "詳細情報", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-bold" }, "作業員名：", -1)),
                _createTextVNode(_toDisplayString(_ctx.operatorName) + " ", 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-bold ml-4" }, "作業員コード：", -1)),
                _createTextVNode(_toDisplayString(_ctx.operatorCode), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-bold" }, "現場名：", -1)),
                _createTextVNode(_toDisplayString(_ctx.siteName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-bold" }, "時間範囲：", -1)),
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.timeRange,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeRange) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { value: 4 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.isSmallScreen ? '4h' : '4時間'), 1),
                      (!_ctx.isSmallScreen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "5分間隔"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { value: 8 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isSmallScreen ? '8h' : '8時間'), 1),
                      (!_ctx.isSmallScreen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "10分間隔"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { value: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.isSmallScreen ? '12h' : '12時間'), 1),
                      (!_ctx.isSmallScreen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "15分間隔"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { value: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.isSmallScreen ? '24h' : '24時間'), 1),
                      (!_ctx.isSmallScreen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "30分間隔"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { style: {"padding-block":"0px"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mb-2 text-lg font-semibold text-gray-700" }, "履歴グラフ", -1)),
              _withDirectives(_createVNode(_component_ChartComponent, {
                chartData: _ctx.chartData,
                showErrorOverlay: _ctx.errorStates.chart,
                onBarClick: _ctx.handleBarClick,
                "legends-orient-right": !_ctx.isSmallScreen,
                onBarsSelected: _ctx.handleBarsSelected
              }, null, 8, ["chartData", "showErrorOverlay", "onBarClick", "legends-orient-right", "onBarsSelected"]), [
                [_directive_loading, _ctx.chartLoading]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatMapTitle()), 1),
              _withDirectives(_createVNode(_component_MapComponent, {
                mode: _ctx.mapDisplayMode,
                mapNewestData: _ctx.mapNewestData,
                mapTrackingData: _ctx.mapTrackingData,
                showErrorOverlay: _ctx.errorStates.map
              }, null, 8, ["mode", "mapNewestData", "mapTrackingData", "showErrorOverlay"]), [
                [_directive_loading, _ctx.mapLoading]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_button, {
              class: "flex items-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTime('back'))),
              type: "primary",
              text: ""
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "material-icons" }, "arrow_back", -1)),
                _createElementVNode("span", _hoisted_18, "前の" + _toDisplayString(_ctx.timeRange) + "時間", 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.formatTimeRange), 1),
            _createVNode(_component_el_button, {
              class: "flex items-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTime('forward'))),
              type: "primary",
              text: "",
              disabled: _ctx.isLatestTimeFrame
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_19, "次の" + _toDisplayString(_ctx.timeRange) + "時間", 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "material-icons" }, "arrow_forward", -1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_footer, { style: {"height":"20px"} })
    ]),
    _: 1
  }))
}